export const TYPES = {
    WEB_RTC_SERVICE: 'IWebRtcService',
    STORAGE_SERVICE: 'IStorage'
}

export type socialNetworkType = 'facebook' | 'youtube' | 'linkedin'
